(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("gamificationNotificationService", ["$rootScope", "$ocLazyLoad", "$injector", gamificationNotificationService]);
    function gamificationNotificationService($rootScope, $ocLazyLoad, $injector) {
        var gamificationNotificationServiceFactory = {};
        var options = {
            delay: 15000,
            startTop: 20,
            startRight: 10,
            verticalSpacing: 20,
            horizontalSpacing: 20,
            positionX: "center",
            positionY: "bottom",
            closeOnClick: false
        };
        function pointsCollected(icon, message, points) {
            $ocLazyLoad.load("Gamification").then(function () {
                var ngAudio = $injector.get("ngAudio");
                var Notification = $injector.get("Notification");
                var sound = ngAudio.play("/audio/gamificationNotification.mp3");
                sound.volume = 0.1;
                var scope = $rootScope.$new();
                scope.icon = icon;
                scope.category = message;
                scope.points = points;
                scope.isMobile = jQuery.browser.mobile;
                options.templateUrl = "app/templates/gamificationNotificationPointsCollectedTemplate.html";
                options.scope = scope;
                Notification(options);
            });
        }
        function tierAchieved(icon, tier) {
            $ocLazyLoad.load("Gamification").then(function () {
                var ngAudio = $injector.get("ngAudio");
                var Notification = $injector.get("Notification");
                var sound = ngAudio.play("/audio/gamificationNotification.mp3");
                sound.volume = 0.1;
                var scope = $rootScope.$new();
                scope.icon = icon;
                scope.tier = tier;
                scope.isMobile = jQuery.browser.mobile;
                options.templateUrl = "app/templates/gamificationNotificationTierAchievedTemplate.html";
                options.scope = scope;
                Notification(options);
            });
        }
        gamificationNotificationServiceFactory.pointsCollected = pointsCollected;
        gamificationNotificationServiceFactory.tierAchieved = tierAchieved;
        return gamificationNotificationServiceFactory;
    }
}());
